/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BranchCreateRequest } from '../../models/branch-create-request';
import { BranchGroup } from '../../models/branch-group';

export interface CreateBranch$Params {
      body: BranchCreateRequest
}

export function createBranch(http: HttpClient, rootUrl: string, params: CreateBranch$Params, context?: HttpContext): Observable<StrictHttpResponse<BranchGroup>> {
  const rb = new RequestBuilder(rootUrl, createBranch.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BranchGroup>;
    })
  );
}

createBranch.PATH = '/api/v1/branches';
